// src/components/ProblemHeaderActions.js
import { Edit, BarChart2 } from 'lucide-react';
import { cn } from '../lib/utils';

const ProblemHeaderActions = ({ 
  problem, 
  isTeacher, 
  onEdit, 
  onProgress, 
  className = '' 
}) => {
  // Don't render anything if user is not a teacher
  if (!isTeacher || !problem) {
    return null;
  }

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onEdit?.(problem.id);
  };

  const handleProgress = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onProgress?.(problem.id);
  };

  return (
    <div className={cn("problem-header-actions flex items-center gap-2 ml-3", className)}>
      <button
        onClick={handleEdit}
        className={cn(
          "action-btn edit-btn",
          "p-1.5 rounded-md border transition-all duration-150",
          "bg-mad-gunmetal border-mad-border-color text-mad-timberwolf",
          "hover:bg-mad-fulvous hover:text-white hover:border-mad-fulvous",
          "hover:transform hover:-translate-y-0.5",
          "focus:outline-none focus:ring-2 focus:ring-mad-fulvous focus:ring-opacity-50",
          "active:transform active:translate-y-0"
        )}
        title="Edit this problem"
        aria-label={`Edit problem: ${problem.title}`}
      >
        <Edit size={16} />
      </button>

      <button
        onClick={handleProgress}
        className={cn(
          "action-btn progress-btn",
          "p-1.5 rounded-md border transition-all duration-150",
          "bg-mad-gunmetal border-mad-border-color text-mad-timberwolf",
          "hover:bg-mad-peel hover:text-mad-gunmetal hover:border-mad-peel",
          "hover:transform hover:-translate-y-0.5",
          "focus:outline-none focus:ring-2 focus:ring-mad-peel focus:ring-opacity-50",
          "active:transform active:translate-y-0"
        )}
        title="View progress for this problem"
        aria-label={`View progress for problem: ${problem.title}`}
      >
        <BarChart2 size={16} />
      </button>
    </div>
  );
};

export default ProblemHeaderActions;